<template lang='pug'>
div
    div.fullwidth(v-if="$route.params.lang == 'en'")

        div.title-container
            h1.product-title Partial Discharge Monitoring Systems
            //- h2.notopmargin BSS offers a range of sensors suitable for measurements of partial discharges in transformers in the ultra-high frequency range, for installation into new transformers or for retrofits.

        router-link.section(to="/en/products/PDM600")
            .column-container
                .column
                    .producttitle PDM-600
                    .subtitle Multi-Sensor Partial Discharge Monitoring System with Flexible Channel Configuration
                    ul
                        li Enables disturbance-immune UHF PD monitoring for transformers and GIS
                        li Up to 6 UHF, electrical (IEC&nbsp60270), acoustic, or TEV PD input channels
                
                .column.alignright
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/PDM-600.webp')
                        img( src='@/assets/photos/product_shots/PDM-600.png', width="100%", alt='BSS PDM-600', title='BSS PDM-600')

        router-link.section(to="/en/products/pdm-600-mobile")
            .column-container
                .column
                    .producttitle PDM-600 Mobile
                    .subtitle Mobile Version of PDM-600 for Temporary PD Monitoring at Transformers and GIS
                    ul
                        li Portable PD Monitoring for up to 6 different PD sensors
                        li Disturbance-immune UHF PD measurement at transformers and gas insulated switchgears (GIS)
                .column.alignright
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/PDM-600-Mobile.webp')
                        img( src='@/assets/photos/product_shots/PDM-600-Mobile.png')

        router-link.section(to="/en/products/PDM80")
            .column-container
                .column
                    .producttitle PDM-80
                    .subtitle 8-channel Partial Discharge Monitoring System
                    ul
                        li Electrical PD monitoring system according to IEC 60270
                        li Connects to various electrical PD sensors (bushing tap sensor, measurement impedance, coupling capacitor)
                .column.alignright
                    picture
                        source(type='image/webp', srcset='@/assets/photos/PDM-80.webp')
                        img( src='@/assets/photos/PDM-80.png')

    div.fullwidth(v-if="$route.params.lang == 'de'")

        div.title-container
            h1.product-title Teilentladungs-Monitoring Systeme
            
        router-link.section(to="/de/products/PDM600")
            .column-container
                .column
                    .producttitle PDM-600
                    .subtitle Multisensor Teilentladungs-Monitoring-System mit flexibler Kanalkonfiguration
                    ul
                        li Störunempfindliches UHF-TE-Monitoring an Transformatoren und GIS
                        li Bis zu 6 UHF-, elektrische (IEC 60270), akustische oder TEV TE-Eingangskanäle
            
                .column.alignright
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/PDM-600.webp')
                        img( src='@/assets/photos/product_shots/PDM-600.png', width="100%", alt='BSS PDM-600', title='BSS PDM-600')

        router-link.section(to="/de/products/pdm-600-mobile")
            .column-container
                .column
                    .producttitle PDM-600 Mobile
                    .subtitle Mobile Version des PDM-600 für temporäres TE-Monitoring an Transformatoren und GIS
                    ul
                        li Portables TE-Monitoring für bis zu 6 verschiedenen Sensoren
                        li Störunempfindliche UHF-Messung an Transformatoren und Gas isolierten Schaltanlagen (GIS)
                .column.alignright
                    picture
                        source(type='image/webp', srcset='@/assets/photos/product_shots/PDM-600-Mobile.webp')
                        img( src='@/assets/photos/product_shots/PDM-600-Mobile.png')

        router-link.section(to="/en/products/PDM80")
            .column-container
                .column
                    .producttitle PDM-80
                    .subtitle 8-kanaliges TE-Monitoringsystemen
                    ul
                        li Elektrisches TE-Monitoring-System gem. IEC 60270
                        li Anschlussmöglichkeit für alle gängigen elektrische TE-Sensortypen (Durchführungssensoren, Ankoppelvierpole, Koppelkondensatoren)
                .column.alignright
                    picture
                        source(type='image/webp', srcset='@/assets/photos/PDM-80.webp')
                        img( src='@/assets/photos/PDM-80.png')
    
</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | TE-Monitoring-Systeme",
            description:
                "Teilentladungs-Monitoring-Systeme für Transformatoren, GIS und Mittelspannungsschaltanlagen",
        },
        en: {
            title: "BSS | PD Monitoring Systems",
            description:
                "Partial Discharge Monitoring System for Transformers, GIS and MV Switchgears",
        },
    },
};
</script>

<style lang='sass' scoped>
@import '@/assets/sass/product_overview.sass'
</style>